import { AxiosResponse } from 'axios';
import { MaterialRequestType } from '../../components/uiParts/MaterialRequestModal';
import { csrfToken, getCsrfToken, instance } from '../db';

// 部材名リクエストAPI
export const postMaterialRequest = async (
  watch: (fieldName: string) => MaterialRequestType,
  alias: string,
  name: string,
  summary: string,
  categoryId: number | null | undefined
): Promise<AxiosResponse> => {
  await getCsrfToken();

  const body = {
    name: watch('materialName'),
    alias: alias,
    product_name: name,
    summary: summary,
    ...(categoryId ? { category_id: categoryId } : {})
  };

  const response = await instance.post('/material_request', body, {
    headers: {
      'X-XSRF-TOKEN': csrfToken
    }
  });

  return response.data;
};
